import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { alertError } from "../../../utils/logger";

function getEmptyCategory() {
	return {
		id: null,
		descripcion: "",
	};
}

const EditOperarioCategoryDialog = (props) => {
	const { title, open, setOpen, data, onSave } = props;

	const [category, setCategory] = useState(getEmptyCategory());

	useEffect(() => {
		if (!open) return;

		setCategory({
			...getEmptyCategory(),
			...data,
		});
	}, [open, data]);

	const handleSubmit = () => {
		if (!category?.descripcion?.trim()) {
			alertError({ error: "La descripción es obligatoria." });
			return;
		}

		onSave({
			id: category.id,
			descripcion: category.descripcion.trim(),
		});
	};

	return (
		<Dialog
			fullWidth
			maxWidth="sm"
			open={open}
			onClose={() => setOpen(false)}
			aria-labelledby="operario-category-dialog"
			className="backdrop"
		>
			<DialogTitle id="operario-category-dialog">{title}</DialogTitle>
			<DialogContent>
				<TextField
					label="Descripción"
					value={category.descripcion}
					onChange={(event) =>
						setCategory({ ...category, descripcion: event.target.value })
					}
					InputLabelProps={{ shrink: true }}
					margin="normal"
					variant="outlined"
					required
					fullWidth
				/>
			</DialogContent>
			<DialogActions>
				<Button
					className="mr-2"
					onClick={() => setOpen(false)}
					variant="outlined"
				>
					Cancelar
				</Button>
				<Button onClick={handleSubmit} variant="outlined" color="primary">
					Guardar
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default EditOperarioCategoryDialog;
